import JustValidate from 'just-validate';

const registrationFormVivaldi = document.getElementById('registration_form_vivaldi');
const validator = new JustValidate('#registration_form_vivaldi');
window.onload = function () {
  validator
    .addField('#name', [
      {
        rule: 'required',
        errorMessage: 'Ime je obavezno',
      },
    ])
    .addField('#lastname', [
      {
        rule: 'required',
        errorMessage: 'Prezime je obavezno',
      },
    ])
    .addField('#email', [
      {
        rule: 'required',
        errorMessage: 'E-mail je obavezan',
      },
      {
        rule: 'email',
        errorMessage: 'Email adresa koju ste uneli je nevažeća.',
      },
    ])
    .addField('#register-terms', [
      {
        rule: 'required',
        errorMessage: 'Polje je obavezno',
      }
    ])
    .addField('#register-privacy', [
      {
        rule: 'required',
        errorMessage: 'Polje je obavezno',
      }
    ])
    .addField('#password', [
      {
        rule: 'required',
        errorMessage: 'Lozinka je obavezna',
      },
      {
        rule: 'minLength',
        value: 8,
        errorMessage: 'Lozinka mora da ima minimalno 8 karaktera.',
      },
    ])
    .addField('#password-confirmation', [
      {
        rule: 'required',
        errorMessage: 'Lozinka je obavezna',
      },
      {
        rule: 'minLength',
        value: 8,
        errorMessage: 'Lozinka mora da ima minimalno 8 karaktera.',
      },
      {
        validator: (value, fields) => {
          if (
            fields['#password'] &&
            fields['#password'].elem
          ) {
            const repeatPasswordValue =
              fields['#password'].elem.value;

            return value === repeatPasswordValue;
          }

          return true;
        },
        errorMessage: 'Lozinke se ne podudaraju. Pokušajte ponovo.',
      },
    ]).onSuccess((() => {
      registrationFormVivaldi.submit()
    })).onFail((() => {
      registrationFormVivaldi.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'start' });
    }))
};

// Make password visible
const seePassword = document.querySelector(".js_see_password");
const passwordInput = document.querySelector(".js_password");
const passwordInputConfirmation = document.querySelector(".js_password_confirmation");

if (seePassword) {
  seePassword.addEventListener('click', () => {
    if (passwordInput.getAttribute("type") === "password") {
      passwordInput.setAttribute("type", "text");
      passwordInputConfirmation.setAttribute("type", "text");
      seePassword.classList.add('visible');
    } else {
      passwordInput.setAttribute("type", "password");
      passwordInputConfirmation.setAttribute("type", "password");
      seePassword.classList.remove('visible');
    }
  })
}